import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { emToPx } from '../repiUtils';
import { Circles } from '../../common/loadingComponent';
import { reportActions } from '../../../store/reportStore';
import { domainActions } from '../../../store/domainStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { repiActions, repiDomain, repiLimits } from '../../../store/repiStore';
import Paging from '../../common/pagingComponent';
import RepiDataCorrectionContract from './dataCorrection/repiDataCorrectionContract';

import '../repi.scss';

class PaymentsHistoryDataCorrection extends React.Component {
    state = {
        page: 1,
        contracts: []
    };

    render() {
        if (isNullOrUndefined(this.props.data))
            return null;

        return (
            <div className="repi-payment-history-container">
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginLeft: "1em" }}>
                    <div className="repi-subsection-header">
                        <Translate id="Repi.Report.PaymentHistory.ContractsAndClaimEnforcements" />
                    </div>
                </div>
                <div ref={(el) => this.setContainerRef(el)} id="repi-contracts">
                    {Object.keys(this.props.domain).find(f => this.props.domain[f].isRequesting)
                        ? <Circles />
                        : this.paginateContracts(this.state.contracts).map((contract, i) => <RepiDataCorrectionContract
                            key={contract.contractId}
                            contract={contract}
                            contractIndex={contract.index}
                            subjectId={this.props.data.subjectId}
                            domain={this.props.domain}
                            pendingData={isNullOrUndefined(this.props.data.pendingData) ? undefined : this.props.data.pendingData[contract.contractId]}
                        />)
                    }
                    {this.renderPaging()}
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.dunningLevels);
        this.props.ensureDomainData(repiDomain.currencies);
        this.setState({ contracts: this.getContracts() });
    }

    renderContract = (key) => {
        return (
            <div key={key}>
                <div className="repi-contract-container"></div>
            </div>
        )
    }

    renderPaging = () => {
        if (isNullOrUndefined(this.state.contracts) || this.state.contracts.length <= repiLimits.dataCorrectionContracts)
            return null;

        const totalPages = Math.ceil(this.state.contracts.length / repiLimits.dataCorrectionContracts).toFixed();
        return (
            <div className="repi-contracts-paging-wrapper">
                <hr/>
                <Paging
                    justify="center"
                    style={{ fontSize: "1.2em" }}
                    selectedPage={this.state.page}
                    totalPages={totalPages}
                    setPage={this.setPage}
                />
            </div>
        );
    }

    getContracts = () => {
        const contracts = get(this.props, "data.contracts");
        return isNullOrUndefined(contracts) ? [] : contracts.map((x, i) => ({ ...x, index: i }));
    }

    paginateContracts = (contracts) => {
        const startIndex = (this.state.page - 1) * repiLimits.dataCorrectionContracts;
        return contracts.slice(startIndex, startIndex + repiLimits.dataCorrectionContracts);
    }

    setPage = (page) => {
        this.setState({ page: page });

        // Navbar height is 3.5em, Repi header height is 4.5em
        if (!isNullOrUndefined(this.containerRef))
            window.scrollTo(0, this.containerRef.offsetTop - (emToPx(3.5) + emToPx(4.5)));
    }

    setContainerRef = (el) => {
        if (isNullOrUndefined(el) || this.containerRef === el)
            return;

        this.containerRef = el;
    }
}

export default connect(
    state => ({ ...state.repi.props, domain: {
        [repiDomain.dunningLevels]: state.domain[repiDomain.dunningLevels],
        [repiDomain.currencies]: state.domain[repiDomain.currencies]
    }}),
    dispatch => bindActionCreators({...repiActions, ...reportActions, ...domainActions}, dispatch)
)(withLocalize(withRouter(PaymentsHistoryDataCorrection)));
